<div class="container container-section container-about">
  <div class="text-container">
    <h2>{{ 'About us' | trans: 'main.about_title' }}</h2>
    <p [innerHTML]="data.content | marked"></p>
  </div>
  <div class="image-container" *ngIf="data?.image?.url">
    <img src="{{data.image.url}}">
  </div>
</div>
